import { render, staticRenderFns } from "./ModalMessageFiles.vue?vue&type=template&id=77d49d00&"
import script from "./ModalMessageFiles.vue?vue&type=script&lang=js&"
export * from "./ModalMessageFiles.vue?vue&type=script&lang=js&"
import style0 from "./ModalMessageFiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports